<template>
  <b-card title="گزارش جدید">
    <b-row>
      <b-col>
        <b-form-group id="input-group-1" label="عنوان گزارش:" label-for="input-1">
          <b-form-input id="input-1" v-model="Report.title" required placeholder="عنوان گزارش"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="input-group-2" label="فایل:" label-for="input-2">
          <b-form-input dir="ltr" id="input-2" v-model="Report.query" required placeholder></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <h4>
          <b-modal id="addField" title="ستون جدید" @ok="AddField()">
            <b-form-group id="newField-title-group" label="عنوان ستون:" label-for="newField-title">
              <b-form-input
                id="newField-title"
                v-model="newField.title"
                required
                placeholder="عنوان گزارش"
              ></b-form-input>
            </b-form-group>
            <b-form-group id="newField-field-group" label="فیلد ستون:" label-for="newField-field">
              <b-form-input
                id="newField-field"
                v-model="newField.field"
                required
                placeholder="فیلد گزارش"
              ></b-form-input>
            </b-form-group>
          </b-modal>ستون ها
          <b-button variant="success" v-b-modal.addField size="sm">جدید</b-button>
        </h4>
        <b-table
        responsive
          style="width: 100%"
          striped
          hover
          show-empty
          empty-text="آیتمی جهت نمایش وجود ندارد"
          :fields="fieldsColumns"
          :items="Report.fields"
        >
          <template v-slot:cell(details)="row">
            <b-link variant="success" :href="'#/ticketDetails/' + row.item.id">جزییات</b-link>
          </template>
        </b-table>
      </b-col>
      <b-col>
        <b-modal id="addButtons" title="دکمه جدید" @ok="AddBtn()">
          <b-form-group id="newBtn-title-group" label="عنوان دکمه:" label-for="newBtn-title">
            <b-form-input
              id="newBtn-title"
              v-model="newBtn.title"
              required
              placeholder="عنوان گزارش"
            ></b-form-input>
          </b-form-group>
          <b-form-group id="newBtn-link-group" label="لینک:" label-for="newBtn-link">
            <b-form-input id="newBtn-link" v-model="newBtn.link" required placeholder="فیلد گزارش"></b-form-input>
          </b-form-group>
          <b-form-group id="newBtn-place-group" label="لینک:" label-for="newBtn-place">
            <b-form-select id="newBtn-place" v-model="newBtn.place" :options="PlaceOptions"></b-form-select>
          </b-form-group>
        </b-modal>
        <h4>
          دکمه ها
          <b-button variant="success" v-b-modal.addButtons size="sm">جدید</b-button>
        </h4>
        <b-table
        responsive
          style="width: 100%"
          striped
          hover
          show-empty
          empty-text="آیتمی جهت نمایش وجود ندارد"
          :fields="BtnsColumns"
          :items="Report.buttons"
        >
          <template v-slot:cell(details)="row">
            <b-link variant="success" :href="'#/ticketDetails/' + row.item.id">جزییات</b-link>
          </template>
        </b-table>
      </b-col>
      <!-- <b-col>
        <h4>پارامتر های جستجو</h4>
      </b-col>-->
    </b-row>
    <b-row>
      <b-col>
        <b-button @click="SaveReport()" variant="success">ذخیره</b-button>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import httpHelper from "../../helpers/httpHelper";
export default {
  name: "addReport",
  data() {
    return {
      Report: {
        fields: [],
        buttons: []
      },
      newField: {
        title: "",
        field: ""
      },
      newBtn: {
        title: "",
        link: ""
      },
      PlaceOptions: [
        { text: "هدر", value: 1 },
        { text: "سطر", value: 2 }
      ],
      fieldsColumns: [
        {
          key: "title",
          label: "عنوان"
        },
        {
          key: "field",
          label: "فیلد"
        }
      ],
      BtnsColumns: [
        {
          key: "title",
          label: "عنوان"
        },
        {
          key: "link",
          label: "لینک"
        }
      ]
    };
  },
  created() {
    if (this.$route.params.id) {
      httpHelper.getData("rp/" + this.$route.params.id).then(res => {
          this.Report = res.result;
      });
    }
  },
  methods: {
    AddField() {
      this.Report.fields.push(this.newField);
      this.newField = { title: "", field: "" };
    },
    AddBtn() {
      this.Report.buttons.push(this.newBtn);
      this.newBtn = { title: "", link: "" };
    },
    SaveReport() {
      httpHelper.postData("report", this.Report).then(res => {
        this.$router.push("/rp/0")
      });
    }
  }
};
</script>